import { render, staticRenderFns } from "./noticeRemind.vue?vue&type=template&id=9abd3638&scoped=true&"
import script from "./noticeRemind.vue?vue&type=script&lang=js&"
export * from "./noticeRemind.vue?vue&type=script&lang=js&"
import style0 from "./noticeRemind.vue?vue&type=style&index=0&id=9abd3638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abd3638",
  null
  
)

export default component.exports